export default {
  'loading': 'Cargando . . .',
  'nombre': 'Nombre',
  'telefono': 'Teléfono',
  'codigo': 'Código',
  'email': 'Email',
  'activo': 'Activo',
  'estado': 'Estado',
  'descripcion': 'Descripción',
  'usuario': 'Usuario',
  'clave': 'Clave',
  'si': 'Si',
  'no': 'No',
  'cargando': 'Cargando...',
  'maestros': {
    'editar': 'Editar',
    'eliminar': 'Eliminar',
  },
  'mensajes': {
    'confirmar': 'Confirmación',
    'pregunta-borrar': '¿Está seguro que quiere eliminar "',
  },
};
